// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Combinators from "../Data.Argonaut.Decode.Combinators/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_TraversableWithIndex from "../Data.TraversableWithIndex/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_Json from "../Fusion.Data.Json/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as URI_Path_Segment from "../URI.Path.Segment/index.js";
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var getField = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var kindIsSymbol = {
    reflectSymbol: function () {
        return "kind";
    }
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL)(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "url";
    }
})())({
    reflectSymbol: function () {
        return "message";
    }
})())(kindIsSymbol)())());
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var gEncodeJsonCons2 = /* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "speed";
    }
})())(kindIsSymbol)();
var encodeJson1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons2)());
var encodeJson2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(gEncodeJsonCons2)({
    reflectSymbol: function () {
        return "jitter";
    }
})())());
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString);
var decodeForeignObject = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson);
var decodeJson1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(decodeForeignObject);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither);
var getField1 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonNumber);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Either.functorEither);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Either.applyEither);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var getField2 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonBoolean);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNumber));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var durationIsSymbol = {
    reflectSymbol: function () {
        return "duration";
    }
};
var getField3 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1({
    reflectSymbol: function () {
        return "numStreams";
    }
})()())(durationIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1({
    reflectSymbol: function () {
        return "maxBytes";
    }
})()())(durationIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "upload";
    }
})()())({
    reflectSymbol: function () {
        return "download";
    }
})()())());
var getField4 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(decodeForeignObject);
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeJsonString)));
var ipv6IsSymbol = {
    reflectSymbol: function () {
        return "ipv6";
    }
};
var dualstackIsSymbol = {
    reflectSymbol: function () {
        return "dualstack";
    }
};
var getField5 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(Data_Argonaut_Decode_Class.gDecodeJsonNil)(ipv6IsSymbol)()())(dualstackIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil)(ipv6IsSymbol)()())(dualstackIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "uploadServer";
    }
})()())({
    reflectSymbol: function () {
        return "downloadServers";
    }
})()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "servers";
    }
})()())({
    reflectSymbol: function () {
        return "id";
    }
})()())());
var getField6 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonJson))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "isp";
    }
})()())({
    reflectSymbol: function () {
        return "ipVersion";
    }
})()())({
    reflectSymbol: function () {
        return "ip";
    }
})()())());
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Either.bindEither);
var forWithIndex = /* #__PURE__ */ Data_TraversableWithIndex.forWithIndex(Data_Either.applicativeEither)(Data_Array_NonEmpty_Internal.traversableWithIndexNonEmptyArray);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(Parsing.showParseError);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Data_Time_Duration.durationSeconds)(Fusion_Data_Duration.durationDuration);
var getField7 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonJson);
var getField8 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Either.altEither);
var $$for = /* #__PURE__ */ Data_Traversable["for"](Data_Either.applicativeEither);
var for1 = /* #__PURE__ */ $$for(Data_Traversable.traversableMaybe);
var for2 = /* #__PURE__ */ $$for(Data_Traversable.traversableArray);
var getField9 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonJson)));
var WarningDE = function (x) {
    return x;
};
var UploadIntermediateDE = function (x) {
    return x;
};
var UploadFinalDE = function (x) {
    return x;
};
var UploadDE = function (x) {
    return x;
};
var SpeedtestOptions = function (x) {
    return x;
};
var PrepareResultDE = function (x) {
    return x;
};
var PingIntermediateDE = function (x) {
    return x;
};
var PingFinalDE = function (x) {
    return x;
};
var PingDE = function (x) {
    return x;
};
var NQValue = function (x) {
    return x;
};
var ModemFinalDE = function (x) {
    return x;
};
var ModemDE = function (x) {
    return x;
};
var DownloadIntermediateDE = function (x) {
    return x;
};
var DownloadFinalDE = function (x) {
    return x;
};
var DownloadDE = function (x) {
    return x;
};
var CompleteDE = function (x) {
    return x;
};
var BenchmarkDE = function (x) {
    return x;
};
var nQValueMemberWarningDE = {
    upcast: coerce
};
var nQValueMemberUploadInterm = {
    upcast: coerce
};
var nQValueMemberUploadFinalD = {
    upcast: coerce
};
var nQValueMemberUploadDE = {
    upcast: coerce
};
var nQValueMemberPrepareResul = {
    upcast: coerce
};
var nQValueMemberPingIntermed = {
    upcast: coerce
};
var nQValueMemberPingFinalDE = {
    upcast: coerce
};
var nQValueMemberPingDE = {
    upcast: coerce
};
var nQValueMemberNQValue = {
    upcast: coerce
};
var nQValueMemberModemFinalDE = {
    upcast: coerce
};
var nQValueMemberModemDE = {
    upcast: coerce
};
var nQValueMemberDownloadInte = {
    upcast: coerce
};
var nQValueMemberDownloadFina = {
    upcast: coerce
};
var nQValueMemberDownloadDE = {
    upcast: coerce
};
var nQValueMemberCompleteDE = {
    upcast: coerce
};
var nQValueMemberBenchmarkDE = {
    upcast: coerce
};
var verifyKind = function (expectedKind) {
    return function (obj) {
        return bind(getField(obj)("kind"))(function (actualKind) {
            var $295 = actualKind === expectedKind;
            if ($295) {
                return pure(Data_Unit.unit);
            };
            return throwError(new Data_Argonaut_Decode_Error.AtKey("kind", new Data_Argonaut_Decode_Error.UnexpectedValue(Data_Argonaut_Core.fromString(actualKind))));
        });
    };
};
var upcast = function (dict) {
    return dict.upcast;
};
var toWarningDE = function (warning) {
    return encodeJson((function () {
        if (warning instanceof Fusion_Data_FSValue.FSWarningDownloadStreamFailed) {
            return {
                kind: "Warning",
                url: warning.value0,
                message: warning.value1
            };
        };
        if (warning instanceof Fusion_Data_FSValue.FSWarningUploadStreamFailed) {
            return {
                kind: "Warning",
                url: warning.value0,
                message: warning.value1
            };
        };
        throw new Error("Failed pattern match at Fusion.Foreign.Data.NQValue (line 371, column 14 - line 373, column 85): " + [ warning.constructor.name ]);
    })());
};
var toUploadIntermediateDE = function (v) {
    return encodeJson1({
        kind: "UploadIntermediate",
        speed: Fusion_Data_Speed.toBps(v.speed)
    });
};
var toUploadFinalDE = function (v) {
    return encodeJson2({
        kind: "UploadFinal",
        speed: Fusion_Data_Speed.toBps(v.speed),
        jitter: Fusion_Data_Speed.toBps(v.jitter)
    });
};
var toDownloadIntermediateDE = function (v) {
    return encodeJson1({
        kind: "DownloadIntermediate",
        speed: Fusion_Data_Speed.toBps(v.speed)
    });
};
var toDownloadFinalDE = function (v) {
    return encodeJson2({
        kind: "DownloadFinal",
        speed: Fusion_Data_Speed.toBps(v.speed),
        jitter: Fusion_Data_Speed.toBps(v.jitter)
    });
};
var stringify = function (dictNQValueMember) {
    var upcast1 = upcast(dictNQValueMember);
    return function (a) {
        var v = upcast1(a);
        return Data_Argonaut_Core.stringify(v);
    };
};
var showBenchmarkDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberBenchmarkDE)
};
var showCompleteDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberCompleteDE)
};
var showDownloadDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberDownloadDE)
};
var showDownloadFinalDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberDownloadFina)
};
var showDownloadIntermediateD = {
    show: /* #__PURE__ */ stringify(nQValueMemberDownloadInte)
};
var showModemDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberModemDE)
};
var showModemFinalDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberModemFinalDE)
};
var showNQValue = {
    show: /* #__PURE__ */ stringify(nQValueMemberNQValue)
};
var showPingDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberPingDE)
};
var showPingFinalDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberPingFinalDE)
};
var showPingIntermediateDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberPingIntermed)
};
var showPrepareResultDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberPrepareResul)
};
var showUploadDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberUploadDE)
};
var showUploadFinalDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberUploadFinalD)
};
var showUploadIntermediateDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberUploadInterm)
};
var showWarningDE = {
    show: /* #__PURE__ */ stringify(nQValueMemberWarningDE)
};
var decodeIpVersion = function (json) {
    return bind(decodeJson(json))(function (v) {
        if (v === "v4") {
            return pure(Fusion_Data_FSValue.IPv4.value);
        };
        if (v === "v6") {
            return pure(Fusion_Data_FSValue.IPv6.value);
        };
        return throwError(new Data_Argonaut_Decode_Error.UnexpectedValue(json));
    });
};
var decodeFSUploadIntermediate = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("UploadIntermediate")(obj))(function () {
            return bind(getField1(obj)("speed"))(function (v1) {
                return pure({
                    speed: Fusion_Data_Speed.fromBps(v1)
                });
            });
        });
    });
};
var decodeFSUploadFinal = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("UploadFinal")(obj))(function () {
            return bind(getField1(obj)("speed"))(function (v1) {
                return bind(getField1(obj)("jitter"))(function (v2) {
                    return pure({
                        speed: Fusion_Data_Speed.fromBps(v1),
                        jitter: Fusion_Data_Speed.fromBps(v2)
                    });
                });
            });
        });
    });
};
var decodeFSPrepareResult = function (v) {
    var getFieldDoubleOptional = function (dictDecodeJson) {
        var getFieldOptional = Data_Argonaut_Decode_Combinators.getFieldOptional(Data_Argonaut_Decode_Class.decodeJsonMaybe(dictDecodeJson));
        return function (obj) {
            return function (key) {
                return mapFlipped(getFieldOptional(obj)(key))(join);
            };
        };
    };
    var getFieldDoubleOptional1 = getFieldDoubleOptional(Data_Argonaut_Decode_Class.decodeJsonNumber);
    var decodeModem = function (obj) {
        return apply(apply(apply(map(function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return apply1(apply1(apply1(map1(function (v5) {
                            return function (v6) {
                                return function (v7) {
                                    return function (v8) {
                                        return {
                                            maxDownloadBookedSpeed: Fusion_Data_Speed.fromBps(v6),
                                            maxDownloadProvisionedSpeed: Fusion_Data_Speed.fromBps(v5),
                                            maxUploadBookedSpeed: Fusion_Data_Speed.fromBps(v8),
                                            maxUploadProvisionedSpeed: Fusion_Data_Speed.fromBps(v7)
                                        };
                                    };
                                };
                            };
                        })(v1))(v2))(v3))(v4);
                    };
                };
            };
        })(getFieldDoubleOptional1(obj)("provisionedDownloadSpeed")))(getFieldDoubleOptional1(obj)("bookedDownloadSpeedMax")))(getFieldDoubleOptional1(obj)("provisionedUploadSpeed")))(getFieldDoubleOptional1(obj)("bookedUploadSpeedMax"));
    };
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("PrepareResult")(obj))(function () {
            return bind(getField2(obj)("isIPv6"))(function (v1) {
                return bind(getField3(obj)("config"))(function (v2) {
                    return bind(getField4(obj)("init"))(function (init) {
                        return bind(getField5(init)("speedtest"))(function (v3) {
                            return bind(getField6(init)("connection"))(function (v4) {
                                return bind(decodeIpVersion(v4.ipVersion))(function (ipVersion) {
                                    return bind(bindFlipped(decodeModem)(getField4(init)("modem")))(function (contractInfo) {
                                        var uploadServerStr = (function () {
                                            if (v1) {
                                                return v3.servers.uploadServer.ipv6;
                                            };
                                            return v3.servers.uploadServer.dualstack;
                                        })();
                                        var downloadServersStrs = (function () {
                                            if (v1) {
                                                return v3.servers.downloadServers.ipv6;
                                            };
                                            return v3.servers.downloadServers.dualstack;
                                        })();
                                        return bind(forWithIndex(downloadServersStrs)(function (index) {
                                            return function (url) {
                                                return lmap(function (err) {
                                                    return new Data_Argonaut_Decode_Error.AtKey("init.speedtest.downloadServers", new Data_Argonaut_Decode_Error.AtIndex(index, new Data_Argonaut_Decode_Error.TypeMismatch("Invalid url: " + show(err))));
                                                })(MST_Data_BasicURL.parse(url));
                                            };
                                        }))(function (downloadUrls) {
                                            return bind(lmap(function (err) {
                                                return new Data_Argonaut_Decode_Error.AtKey("init.speedtest.uploadServer", new Data_Argonaut_Decode_Error.TypeMismatch("Invalid url: " + show(err)));
                                            })(MST_Data_BasicURL.parse(uploadServerStr)))(function (uploadUrl) {
                                                var downloadAddressesWithStats = mapFlipped1(downloadUrls)(function (downloadUrl) {
                                                    return {
                                                        load: downloadUrl,
                                                        stats: new Data_Maybe.Just(MST_Data_BasicURL.replacePath([ URI_Path_Segment.segmentFromString("tcp-stats") ])(downloadUrl))
                                                    };
                                                });
                                                return pure({
                                                    info: {
                                                        speedtestID: v3.id,
                                                        contractInfo: contractInfo
                                                    },
                                                    stepDetails: {
                                                        download: {
                                                            numStreams: v2.download.numStreams,
                                                            downloadAddresses: downloadAddressesWithStats,
                                                            duration: convertDuration(v2.download.duration)
                                                        },
                                                        upload: {
                                                            numStreams: 2,
                                                            uploadAddress: {
                                                                load: uploadUrl,
                                                                stats: Data_Maybe.Nothing.value
                                                            },
                                                            duration: convertDuration(v2.upload.duration)
                                                        }
                                                    },
                                                    init: {
                                                        connection: {
                                                            ip: v4.ip,
                                                            ipVersion: ipVersion,
                                                            isp: v4.isp
                                                        }
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
var decodeFSPingIntermediate = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("PingIntermediate")(obj))(function () {
            return bind(getField1(obj)("pingTime"))(function (v1) {
                return pure({
                    pingTime: convertDuration(v1)
                });
            });
        });
    });
};
var decodeFSPingFinal = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("PingFinal")(obj))(function () {
            return bind(getField1(obj)("pingTime"))(function (v1) {
                return bind(getField1(obj)("jitter"))(function (v2) {
                    return pure({
                        pingTime: convertDuration(v1),
                        jitter: convertDuration(v2)
                    });
                });
            });
        });
    });
};
var decodeFSModemFinal = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("ModemFinal")(obj))(function () {
            return bind(getField4(obj)("modemFinal"))(function (v1) {
                return bind(getField(v1)("kind"))(function (v2) {
                    if (v2 === "ModemFinalAvailable") {
                        return bind(bindFlipped(Fusion_Data_Json.decodeAsBps)(getField7(v1)("speed")))(function (v3) {
                            return pure({
                                modemFinal: new Fusion_Data_FSValue.ModemFinalAvailable({
                                    speed: v3
                                })
                            });
                        });
                    };
                    if (v2 === "ModemFinalDidNotRun") {
                        return bind(getField(v1)("reason"))(function (v3) {
                            return bind((function () {
                                if (v3 === "NotNeeded") {
                                    return pure(Fusion_Data_FSValue.NotNeeded.value);
                                };
                                if (v3 === "NotAvailable") {
                                    return pure(Fusion_Data_FSValue.NotAvailable.value);
                                };
                                if (v3 === "NotACustomer") {
                                    return pure(Fusion_Data_FSValue.NotACustomer.value);
                                };
                                return throwError(new Data_Argonaut_Decode_Error.AtKey("modemFinal", new Data_Argonaut_Decode_Error.AtKey("reason", new Data_Argonaut_Decode_Error.UnexpectedValue(Data_Argonaut_Core.fromString(v3)))));
                            })())(function (reason) {
                                return pure({
                                    modemFinal: new Fusion_Data_FSValue.ModemFinalDidNotRun({
                                        reason: reason
                                    })
                                });
                            });
                        });
                    };
                    if (v2 === "ModemFinalFailed") {
                        return bind(getField8(v1)("message"))(function (v3) {
                            return pure({
                                modemFinal: new Fusion_Data_FSValue.ModemFinalFailed({
                                    message: v3
                                })
                            });
                        });
                    };
                    return throwError(new Data_Argonaut_Decode_Error.AtKey("kind", new Data_Argonaut_Decode_Error.UnexpectedValue(Data_Argonaut_Core.fromString(v2))));
                });
            });
        });
    });
};
var decodeFSDownloadIntermediate = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("DownloadIntermediate")(obj))(function () {
            return bind(getField1(obj)("speed"))(function (v1) {
                return pure({
                    speed: Fusion_Data_Speed.fromBps(v1)
                });
            });
        });
    });
};
var decodeFSDownloadFinal = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        return discard(verifyKind("DownloadFinal")(obj))(function () {
            return bind(getField1(obj)("speed"))(function (v1) {
                return bind(getField1(obj)("jitter"))(function (v2) {
                    return pure({
                        speed: Fusion_Data_Speed.fromBps(v1),
                        jitter: Fusion_Data_Speed.fromBps(v2)
                    });
                });
            });
        });
    });
};
var decodeFSValue = function (v) {
    return alt(map(Fusion_Data_FSValue.PrepareResult.create)(decodeFSPrepareResult(v)))(alt(map(Fusion_Data_FSValue.DownloadIntermediate.create)(decodeFSDownloadIntermediate(v)))(alt(map(Fusion_Data_FSValue.DownloadFinal.create)(decodeFSDownloadFinal(v)))(alt(map(Fusion_Data_FSValue.UploadIntermediate.create)(decodeFSUploadIntermediate(v)))(alt(map(Fusion_Data_FSValue.UploadFinal.create)(decodeFSUploadFinal(v)))(alt(map(Fusion_Data_FSValue.PingIntermediate.create)(decodeFSPingIntermediate(v)))(alt(map(Fusion_Data_FSValue.PingFinal.create)(decodeFSPingFinal(v)))(map(Fusion_Data_FSValue.ModemFinal.create)(decodeFSModemFinal(v)))))))));
};
var decodeFSSpeedtestOptions = function (v) {
    return bind(decodeJson1(v))(function (obj) {
        var decodeArray = function (maj) {
            return for1(maj)(function (aj) {
                return for2(aj)(function (j) {
                    return decodeFSValue(j);
                });
            });
        };
        return bind(getField9(obj)("downloadMockData"))(function (v1) {
            return bind(decodeArray(v1))(function (downloadMockData) {
                return bind(getField9(obj)("uploadMockData"))(function (v2) {
                    return bind(decodeArray(v2))(function (uploadMockData) {
                        return pure({
                            downloadMockData: downloadMockData,
                            uploadMockData: uploadMockData
                        });
                    });
                });
            });
        });
    });
};
export {
    BenchmarkDE,
    ModemFinalDE,
    decodeFSDownloadFinal,
    decodeFSDownloadIntermediate,
    decodeFSModemFinal,
    decodeFSPingFinal,
    decodeFSPingIntermediate,
    decodeFSPrepareResult,
    decodeFSSpeedtestOptions,
    decodeFSUploadFinal,
    decodeFSUploadIntermediate,
    decodeFSValue,
    stringify,
    toDownloadFinalDE,
    toDownloadIntermediateDE,
    toUploadFinalDE,
    toUploadIntermediateDE,
    toWarningDE,
    upcast,
    nQValueMemberNQValue,
    nQValueMemberPrepareResul,
    nQValueMemberBenchmarkDE,
    nQValueMemberDownloadDE,
    nQValueMemberDownloadInte,
    nQValueMemberDownloadFina,
    nQValueMemberUploadDE,
    nQValueMemberUploadInterm,
    nQValueMemberUploadFinalD,
    nQValueMemberPingDE,
    nQValueMemberPingIntermed,
    nQValueMemberPingFinalDE,
    nQValueMemberCompleteDE,
    nQValueMemberModemDE,
    nQValueMemberModemFinalDE,
    nQValueMemberWarningDE,
    showNQValue,
    showPrepareResultDE,
    showBenchmarkDE,
    showDownloadDE,
    showDownloadIntermediateD,
    showDownloadFinalDE,
    showUploadDE,
    showUploadIntermediateDE,
    showUploadFinalDE,
    showPingDE,
    showPingIntermediateDE,
    showPingFinalDE,
    showCompleteDE,
    showModemDE,
    showModemFinalDE,
    showWarningDE
};
